import { jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M49.952 14.063 39.411 45.686l-6.289-12.945-.604-1.245-1.246-.604-12.966-6.289 31.646-10.541m6.317-6.314L7.73 23.916l21.798 10.573 10.573 21.763L56.269 7.749h-.001l.001-.001Z"
      }
    )
  }
);
export {
  t as Navigation
};
